module.exports = __webpack_public_path__ + "static/media/scene5_didi2.14aabc73.wav";